var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPGeneralPlantHeatPump = function SvgPGeneralPlantHeatPump(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 368.1,
    y: 396.1,
    width: 64,
    height: 40,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.1,
    y: 436.1,
    width: 8,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.1,
    y: 436.1,
    width: 8,
    height: 2,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 383.1,
    cy: 416.1,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M381,416.8c-2.2,1.4-3.7,3.8-3.7,6.5c0,0.2,0,0.3,0,0.5c0.1,0.8,0.5,1.4,1.2,1.7l0,0c1.3,0.6,2.7,1,4.1,1.1 c0.2,0,0.3-0.1,0.3-0.3v-0.1l0,0c-0.6-1.1-1-2.4-1-3.7c0-1.5,0.5-2.9,1.3-4.1h-0.1C382.1,418.3,381.3,417.7,381,416.8L381,416.8z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1,418.3c0.6,2.5,2.4,4.7,5,5.5c0.1,0,0.3,0.1,0.4,0.1c0.8,0.2,1.5-0.1,2-0.6l0,0c1-1,1.8-2.2,2.3-3.6 c0-0.2,0-0.3-0.2-0.4h-0.1l0,0c-1.2,0.3-2.5,0.2-3.8-0.2c-1.5-0.5-2.6-1.4-3.6-2.5v0.1C384.9,417.7,384,418.3,383.1,418.3 L383.1,418.3z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.2,416.7c2.6,0.2,5.2-0.9,6.8-3c0.1-0.1,0.2-0.2,0.3-0.4c0.4-0.7,0.4-1.5,0-2.1l0,0 c-0.6-1.3-1.6-2.4-2.7-3.3c-0.1-0.1-0.3-0.1-0.4,0.1v0.1l0,0c-0.1,1.3-0.6,2.5-1.4,3.6c-0.9,1.2-2.1,2.1-3.5,2.6 c0,0,0.1,0,0.1,0.1C385.2,414.9,385.5,415.8,385.2,416.7L385.2,416.7z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.4,414.3c1-2.4,0.8-5.2-0.8-7.4c-0.1-0.1-0.2-0.2-0.3-0.4c-0.5-0.6-1.3-0.8-2-0.7l0,0 c-1.4,0.2-2.8,0.7-4,1.6c-0.1,0.1-0.2,0.3-0.1,0.4l0.1,0.1l0,0c1.2,0.5,2.2,1.3,3,2.4c0.9,1.2,1.4,2.7,1.4,4.1l0.1-0.1 C382.6,413.7,383.6,413.8,384.4,414.3L384.4,414.3z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.8,414.3c-2-1.7-4.7-2.4-7.3-1.5c-0.1,0-0.3,0.1-0.4,0.1c-0.7,0.3-1.2,1-1.3,1.7l0,0 c-0.2,1.4-0.1,2.9,0.3,4.3c0,0.2,0.2,0.2,0.4,0.2c0,0,0.1,0,0.1-0.1l0,0c0.9-1,1.9-1.7,3.2-2.1c1.5-0.5,2.9-0.5,4.4-0.1v-0.1 C380.7,415.9,381.1,414.9,381.8,414.3L381.8,414.3z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.1,
    cy: 416.1,
    r: 2.2,
    fill: "#C4C4C4",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 404.1,
    y: 400.1,
    width: 24,
    height: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.1,
    y: 406.1,
    width: 24,
    height: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.1,
    y: 412.1,
    width: 24,
    height: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.1,
    y: 418.1,
    width: 24,
    height: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.1,
    y: 424.1,
    width: 24,
    height: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.1,
    y: 430.1,
    width: 24,
    height: 2,
    fill: "#FFFFFF"
  }))));
};
export default SvgPGeneralPlantHeatPump;